export default __webpack_public_path__ + "static/media/BlackOnTransparent.60c739ac.svg";